<template>
  <div>
    <wc-dialog
      :loading='loading'
      :showDialog='showDialog'
      :title='value.id ? "Edit notice properties" : "Create a New Notice"'
      :icon='$store.state.icons.modules.notices.icon'
      @cancel='cancel'
      @save='save'
      width='600'
      :loadingButtons='loading'
      :disableButtons='!isFormValid'
    >
      <template v-slot:dialog-actions>
        <v-tooltip top open-delay='500' :disabled='!value.system_notice'>
          <template v-slot:activator='{ on }'>
            <div v-on='on' class='d-inline-block'>
              <v-btn v-if='value.id' small elevation='0' color='error' :disabled='value.system_notice' @click='showConfirmArchive = true'>
                Archive
              </v-btn>
            </div>
          </template>
          System Notices cannot be archived
        </v-tooltip>
      </template>

      <v-form v-model='isFormValid' ref='form'>
        <v-row>

          <v-col cols='4'>
            <v-select
              :items='$store.state.misc.divisions'
              item-value='id'
              item-text='division'
              label='Division'
              v-model='value.division'
              :rules='[rules.required]'
              :disabled='!!value.division'
              hint='cannot be changed once set'
              persistent-hint
            ></v-select>
          </v-col>

          <v-col cols='8'>
            <v-text-field
              label='Name'
              :rules='[rules.required]'
              v-model='value.name'
              maxlength='50'
              counter
            ></v-text-field>
          </v-col>

          <v-col cols='12'>
            <v-text-field
              label='Helpful Info'
              v-model='value.description'
              maxlength='80'
              counter
              hint='(to help the user know when to use, or not to use this notice)'
              persistent-hint
            ></v-text-field>
          </v-col>

          <v-col cols='12'>
            <v-text-field
              label='Subject'
              v-model='value.subject'
              :rules='[rules.required]'
              maxlength='240'
              counter
              hint='subject line for email / attention line for snail mail'
              persistent-hint
            ></v-text-field>
          </v-col>

        </v-row>
      </v-form>
    </wc-dialog>

    <wc-confirm
        :showDialog='showConfirmArchive'
        saveText="Yes, Archive"
        @cancel='showConfirmArchive = false'
        @confirm='archiveNotice'
    >
      Archiving this notice will remove this notice from the main list.<br><br>
      <b>This cannot be undone from the CPM</b>
    </wc-confirm>

  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'notices-dashboard',
  mixins: [formRules],
  props: {
    showDialog: {
      required: true,
      type: Boolean
    },
    value: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isFormValid: false,
    showConfirmArchive: false
  }),
  methods: {
    save() {
      this.$emit('save')
    },
    cancel () {
      this.$emit('cancel')
    },
    resetForm () {
      this.$nextTick(() => {
        this.$refs.form.reset()
      })
    },
    resetValidate () {
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    archiveNotice () {
      this.value.archived = true
      this.save()
      this.showConfirmArchive = false
    }
  }
}
</script>